import { IJOIST_INPUT_TYPE } from '../../../../../utils/constants'
import { createGenericSlice } from '../../../../../utils/slices'

export const joistSlice = createGenericSlice({
  name: 'joist',
  initialState: {
    type: 'solidSawn',
    material: 1,
    width: '2x',
    depth: 6,
    ply: 1,
    isRough: false,
    memberID: 'Joist 1',
    ijoistInputType: IJOIST_INPUT_TYPE.MANUFACTURER,
    load: 0,
    uplift: 0,
  },
  reducers: {
    updateLoadsCalculation: (state, action) => {
      state.loads = { ...state.loads, ...action.payload }
    },
  },
})

export const joistActions = joistSlice.actions
